import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  field: {
    width: "100%",
  },
  helpText: {
    color: tokens.colorNeutralForeground3,
    marginTop: "-5px",
    marginBottom: "15px",
    marginLeft: "2px",
  },
});
